export const CREATE_HOLIDAY = "CREATE_HOLIDAY";
export const UPDATE_HOLIDAY = "UPDATE_HOLIDAY";
export const FETCH_HOLIDAY_BY_ACCOUNT = "FETCH_HOLIDAY_BY_ACCOUNT";
export const REMOVE_HOLIDAY = "REMOVE_HOLIDAY";
export const GET_HOLIDAYS_FOR_VALIDATION = "GET_HOLIDAYS_FOR_VALIDATION";
